<template>
  <div>
    <div v-if="muestraCabecera" class="cabecera-pedido">
      <b-notification v-if="!fueProcesado" type="is-warning">
        <b-icon icon="exclamation-circle"></b-icon>
        <span class="has-text-weight-medium">
          Este pedido fue generado en SAP, pero a&uacute;n no se ha generado la
          factura de anticipo y/o no se ha ingresado el pago. Mientras no se
          haga esto, no se podr&aacute; procesar dicho documento en MOPI.
        </span>
      </b-notification>
      <strong>Pedido</strong>
      <table class="table is-bordered is-narrow is-fullwidth">
        <tbody>
          <tr>
            <td>Id</td>
            <td>
              <strong>{{ pedido.id }}</strong>
            </td>
            <td>Orden Venta</td>
            <td>
              <strong>{{ pedido.numeroVenta }}</strong>
            </td>
            <td>Tipo Documento</td>
            <td>
              <strong>{{ pedido.tipoVenta }}</strong>
            </td>
            <td>N&deg; Documento</td>
            <td>
              <strong>{{ pedido.numeroDocumento }}</strong>
            </td>
          </tr>
          <tr>
            <td>Cliente</td>
            <td colspan="4">
              <strong>{{ pedido.cliente.nombre }}</strong>
              <b-tag v-if="esClienteCampeon" class="ml-2" type="is-success">
                Campe&oacute;n
              </b-tag>
            </td>
            <td>Vendedor</td>
            <td colspan="2">
              <strong>{{ pedido.vendedor.nombre }}</strong>
            </td>
          </tr>
          <tr>
            <td>Fecha</td>
            <td colspan="2">
              <strong>{{ fechaEmision }}</strong>
            </td>
            <td>Tipo Entrega</td>
            <td>
              <strong>{{ pedido.tipoEntrega.nombre }}</strong>
            </td>
            <td>Fecha Entrega</td>
            <td colspan="2">
              <strong>{{ fechaEntrega }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="puedeDespacharPedido" class="botonera">
        <router-link
          title="Despachar pedido"
          :to="{ path: `/cierre/${pedido.id}` }"
        >
          <b-button icon-left="box-open" type="is-info">
            Entregar pedido
          </b-button>
        </router-link>
      </div>
      <table
        v-if="muestraAsignacion"
        class="table is-bordered is-narrow is-fullwidth"
      >
        <tbody>
          <tr>
            <td>Ingresado</td>
            <td colspan="1">
              <strong>{{ fecha }}</strong>
            </td>
            <td>Pickeador</td>
            <td colspan="1">
              <strong>{{ responsable }}</strong>
              <b-tag v-if="esAsignacionManual" class="ml-2" type="is-warning">
                Manual
              </b-tag>
            </td>
            <td>Tipo Pedido</td>
            <td>
              <strong>{{ pedido.tipoPedido }}</strong>
            </td>
            <td>Zona</td>
            <td>
              <strong>{{ zona }}</strong>
            </td>
            <td>Estado</td>
            <td>
              <strong>{{ pedido.estado }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="cabecera-detalle">
      <strong>{{ titulo }}</strong>
      <table class="table is-bordered is-narrow is-fullwidth">
        <tbody>
          <tr>
            <td>Ingresado</td>
            <td colspan="1">
              <strong>{{ fecha }}</strong>
            </td>
            <td>Pickeador</td>
            <td colspan="1">
              <strong>{{ responsable }}</strong>
              <b-tag v-if="esAsignacionManual" class="ml-2" type="is-warning">
                Manual
              </b-tag>
            </td>
            <td>Tipo Pedido</td>
            <td>
              <strong>{{ pedido.tipoPedido }}</strong>
            </td>
            <td>Zona</td>
            <td>
              <strong>{{ zona }}</strong>
            </td>
            <td>Estado</td>
            <td>
              <strong>{{ pedido.estado }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="muestraDetalle">
      <div v-if="!esUsuarioMonitor" class="botonera">
        <b-button
          v-if="puedeAsignarPedido"
          icon-left="user-check"
          type="is-primary"
          @click="asignarPedido(pedido.id)"
        >
          Asignar Pedido
        </b-button>
        <b-button
          v-if="puedeImprimirPedido"
          icon-left="print"
          type="is-info"
          @click="imprimirPedido(pedido.id)"
        >
          Imprimir Pedido
        </b-button>
        <!-- BOTÓN DESHABILITADO POR SOLICITUD DEL USUARIO FINAL (2026-05-28)
             La funcionalidad se mantiene intacta. Para rehabilitar, reemplazar v-if="false" por v-if="puedeImprimirDocumentoSap".
        <b-button
          class="ml-1"
          icon-left="print"
          type="is-info"
          :loading="imprimiendoDocumentoSap"
          :disabled="imprimiendoDocumentoSap"
          @click="imprimirDocumentoSapHandle"
        >
          Imprimir documento SAP
        </b-button>
        -->
        <b-modal
          :active.sync="estaModalAbierto"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          @close="cerrarModalHandle"
        >
          <seleccion-asignacion
            :bodega="bodega"
            :pedido="pedido"
            @cancelar="cerrarModalHandle"
          />
        </b-modal>
      </div>
      <table class="table is-bordered is-narrow is-fullwidth">
        <thead>
          <th width="3%"><b-icon icon="hashtag"></b-icon></th>
          <th width="7%">C&oacute;digo</th>
          <th>Descripci&oacute;n</th>
          <th width="8%">U. Medida</th>
          <th width="8%">Cantidad</th>
          <th width="8%">Entregado</th>
          <th width="8%">Stock</th>
          <th width="5%">Calzado</th>
          <th width="8%">N&deg; Entrega</th>
          <th width="6%">Modif.</th>
        </thead>
        <tbody>
          <tr v-if="itemsConStock.length === 0">
            <td colspan="10">
              <strong>Sin registros</strong>
            </td>
          </tr>
          <visor-pedido-item
            v-for="item in itemsConStock"
            v-else
            :key="`item-con-stock-${item.id}`"
            :item="item"
          />
          <tr v-if="itemsSinStock.length > 0">
            <td colspan="10">
              <strong>&Iacute;tems sin Stock</strong>
            </td>
          </tr>
          <visor-pedido-item
            v-for="item in itemsSinStock"
            :key="`item-sin-stock-${item.id}`"
            :item="item"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import SeleccionAsignacion from '@/components/monitorUsuario/SeleccionAsignacion.vue'
import VisorPedidoItem from '@/components/visor/VisorPedidoItem.vue'
import { pedidoService } from '@/services'
import documentoService from '@/services/documento.service'
import {
  resolverDocumentoSapDesdeContexto,
  resolverDocumentoSapDesdePedido
} from '@/services/sap-print-resolver.service'

export default {
  name: 'VisorPedido',
  components: {
    VisorPedidoItem,
    SeleccionAsignacion
  },
  props: {
    pedido: {
      type: Object,
      required: true
    },
    hayPedidoPadre: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      estaModalAbierto: false,
      imprimiendoDocumentoSap: false
    }
  },
  computed: {
    ...mapGetters('monitor', ['bodega']),
    fechaEmision() {
      return format(parseISO(this.pedido.fechaEmision), 'dd/MM/yyyy')
    },
    fecha() {
      return format(parseISO(this.pedido.fecha), 'dd/MM/yyyy HH:mm:ss')
    },
    fechaEntrega() {
      return this.pedido.fechaEntrega
        ? format(parseISO(this.pedido.fechaEntrega), 'dd/MM/yyyy HH:mm:ss')
        : ''
    },
    itemsConStock() {
      const items = [...this.pedido.items]
        .filter((orig) => !orig.esKit)
        .reduce((list, orig) => {
          const item = { ...orig }
          if (item.stock > 0) {
            if (
              item.stock >= item.cantidadSolicitada &&
              item.tipoModificacion.id !== '3'
            ) {
              list.push(item)
            }
          }
          return list
        }, [])
      return items.sort((a, b) => {
        if (a.linea > b.linea) return 1
        if (a.linea < b.linea) return -1
        return 0
      })
    },
    itemsSinStock() {
      const items = [...this.pedido.items]
        .filter((orig) => !orig.esKit)
        .reduce((list, orig) => {
          const item = { ...orig }
          if (
            item.stock < item.cantidadSolicitada &&
            item.tipoModificacion.id !== '3'
          ) {
            item.cantidadSolicitada -= item.stock
            item.stock = 0
            list.push(item)
          }
          return list
        }, [])
      return items.sort((a, b) => {
        if (a.linea > b.linea) return 1
        if (a.linea < b.linea) return -1
        return 0
      })
    },
    responsable() {
      return this.pedido.responsable
        ? this.pedido.responsable.nombre
        : 'No asignado'
    },
    titulo() {
      return `Ítems${
        this.pedido.esSubpedido ? ` subpedido #${this.pedido.id}` : ''
      }`
    },
    zona() {
      if (this.pedido.zona) return this.pedido.zona.nombre
      return this.pedido.tipoPedido === 'Multiple' ? 'Varias' : 'Sin Zona'
    },
    puedeAsignarPedido() {
      return (
        this.bodega.puedePickearVendedor &&
        this.pedido.estado.toLowerCase() === 'clasificado'
      )
    },
    puedeImprimirPedido() {
      const estados = ['enejecucion', 'completado', 'despachado']
      return (
        this.bodega.puedeReimprimir &&
        estados.includes(this.pedido.estado.toLowerCase()) &&
        !this.esPedidoMultiplePadre
      )
    },
    puedeDespacharPedido() {
      return (
        this.pedido.estado.toLowerCase() === 'completado' &&
        !this.pedido.esSubpedido
        // &&
        //! this.esUsuarioMonitor
      )
    },
    fueProcesado() {
      return this.pedido.estado.toLowerCase() !== 'ingresado'
    },
    esClienteCampeon() {
      return this.pedido.cliente?.esCampeon === true
    },
    esAsignacionManual() {
      return this.pedido.asignacionManual === true
    },
    esPedidoMultiplePadre() {
      return (
        this.pedido.pedidoPadreId === null &&
        !this.pedido.esSubpedido &&
        ['Múltiple', '3'].includes(this.pedido.tipoPedido)
      )
    },
    muestraCabecera() {
      return !this.pedido.esSubpedido || this.numeroPedidos === 1
    },
    muestraDetalle() {
      return !this.esPedidoMultiplePadre
    },
    muestraAsignacion() {
      return (
        !this.pedido.esSubpedido &&
        (!this.hayPedidoPadre || !this.esPedidoMultiplePadre)
      )
    },
    esUsuarioMonitor() {
      // Si usuario tiene rol Monitor, no se muestran acciones
      return this.bodega.roles.some((rol) => rol.id === 6)
    },
    documentoSapResuelto() {
      return (
        resolverDocumentoSapDesdeContexto({ pedido: this.pedido }) ||
        resolverDocumentoSapDesdePedido(this.pedido)
      )
    },
    puedeImprimirDocumentoSap() {
      return (
        this.bodega?.facturarDesdeMopi === true &&
        Boolean(this.documentoSapResuelto) &&
        this.documentoSapResuelto?.tipo !== 'transferencia'
      )
    }
  },
  methods: {
    asignarPedido(id) {
      this.estaModalAbierto = true
    },
    cerrarModalHandle() {
      this.estaModalAbierto = false
      this.$emit('update', this.pedido.id)
    },
    imprimirPedido(id) {
      pedidoService
        .imprimirPedido(id)
        .then(() => {
          this.notificarAccionCompletada(
            'Se envió impresión de picking list correctamente'
          )
        })
        .catch((error) => this.procesarError(error))
    },
    async imprimirDocumentoSapHandle() {
      if (this.imprimiendoDocumentoSap) return

      const documento = this.documentoSapResuelto
      if (!documento) {
        this.notificarError('Documento SAP aun no disponible para impresion')
        return
      }

      this.imprimiendoDocumentoSap = true
      try {
        await documentoService.imprimirDocumentoSap(
          documento.tipo,
          documento.docEntry
        )
      } catch (error) {
        const responseData = error?.response?.data
        let detalleError =
          error?.mensajeDetallado || error?.response?.data?.error || ''

        if (!detalleError && typeof responseData === 'string') {
          try {
            const responseDataParseada = JSON.parse(responseData)
            detalleError =
              responseDataParseada?.error || responseDataParseada?.Error || ''
          } catch (_) {
            detalleError = responseData.trim()
          }
        } else if (!detalleError) {
          detalleError = responseData?.error || responseData?.Error || ''
        }

        detalleError = detalleError || error?.message
        const mensaje = detalleError
          ? `Error al abrir el documento para impresión: ${detalleError}`
          : 'Error al abrir el documento para impresión'
        this.notificarError(mensaje)
      } finally {
        this.imprimiendoDocumentoSap = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.botonera {
  margin-bottom: 0.5em;
  margin-top: 0.5em;
}

.cabecera-detalle {
  margin-top: 15px;
  margin-bottom: 20px;
}
</style>
